import { closings } from "./closings";
import { extract } from "./extract";
import { debtorsReport } from "./debtors-report";

export const multivendor = {
	closings,
	extract,
	debtorsReport,
	productsSold: {
		title: "Productos vendidos por vendor",
		activeTab: "product-sold-by-vendor",
		bonus: "Bono por producto",
	},
	revenues: {
		title: "Facturación por vendor",
		description:
			"Informe de relación de facturación y cada vendor registrado como parte del local.",
		period: "valores referentes a los períodos {{ since }} - {{ until }}",
		activeTab: "vendors-revenue",
		columns: {
			name: "Vendor",
			totalSoldValue: "Productos vendidos",
			totalTipValue: "Servicio",
			subtotal: "Subtotal",
			rent: "Alquiler",
			revenue: "Ingreso",
			billing: "Facturación",
			percentageFee: "Tasa",
			salesFee: "Tasa Sobre Ventas",
			salesFeeValue: "Transferencia de Ventas",
			serviceFee: "Tasa Sobre Servicio",
			serviceFeeValue: "Transferencia de Servicio",
			percentageFeeText: "Tasa en {{fee}}",
			adjustValue: "Ajustes",
			electrical: "Eléctrica",
			hydraulics: "Hidráulica",
			supply: "Provisión",
			cleaning: "Limpieza",
			other: "Otros",
			cashRetention: "Retención de Efectivo",
			singleProductReturns: "Devoluciones individuales",
			cashPayment: "Pago en efectivo",
			voucherPayment: "Pago en voucher",
			creditPayment: "Pago en crédito",
			debitPayment: "Pago en débito",
			total: "Total",
			totalSoldValueInCredit: "Facturación en Crédito",
			totalSoldValueInDebit: "Facturación en Débito",
			totalSoldValueInPix: "Facturación en Pix",
			creditFee: "Tasa sobre Crédito",
			debitFee: "Tasa sobre Débito",
			pixFee: "Tasa sobre Pix",
			totalSoldValueInCreditFeeValue: "Cobro sobre Crédito",
			totalSoldValueInDebitFeeValue: "Cobro sobre Débito",
			totalSoldValueInPixFeeValue: "Cobro sobre Pix",
			totalSoldValueInOtherPaymentMethods: "Facturación en otros métodos de pago",
			billingTooltip:
				"Esta columna se refiere a la suma de valores facturados por el vendor en productos, servicio, ajustes y sobra de recarga.",
			revenueTooltip:
				"Esta columna es el resultado de la facturación menos todas las tasas y ajustes cobrados del vendor.",
			voucherRetention: "Retención de voucher",
			productsFee: "Transferencia de Productos con Tasa Especial",
			floorComplement: "Complemento de mínimo garantizado",
			rechargeLeftovers: "Sobra de recarga",
		},
		sheet: {
			title: "Facturación por vendor",
			filename: "facturacion_por_vendor_en_local",
			columns: {
				name: "Vendor",
				totalSoldValue: "Productos vendidos",
				totalTipValue: "Servicio",
				subtotal: "Subtotal",
				rent: "Alquiler",
				revenue: "Ingreso",
				billing: "Facturación",
				percentageFee: "Tasa",
				salesFee: "Tasa Sobre Ventas",
				salesFeeValue: "Transferencia de Ventas",
				serviceFee: "Tasa Sobre Servicio",
				serviceFeeValue: "Transferencia de Servicio",
				percentageFeeText: "Tasa en {{fee}}",
				adjustValue: "Ajustes",
				electrical: "Eléctrica",
				hydraulics: "Hidráulica",
				supply: "Provisión",
				cleaning: "Limpieza",
				other: "Otros",
				cashRetention: "Retención de Efectivo",
				singleProductReturns: "Devoluciones individuales",
				totalSoldValueInCredit: "Facturación en Crédito",
				totalSoldValueInDebit: "Facturación en Débito",
				totalSoldValueInPix: "Facturación en Pix",
				creditFee: "Tasa sobre Crédito",
				debitFee: "Tasa sobre Débito",
				pixFee: "Tasa sobre Pix",
				totalSoldValueInCreditFeeValue: "Cobro sobre Crédito",
				totalSoldValueInDebitFeeValue: "Cobro sobre Débito",
				totalSoldValueInPixFeeValue: "Cobro sobre Pix",
				totalSoldValueInOtherPaymentMethods: "Facturación en otros métodos de pago",
				voucherRetention: "Retención de voucher",
				productsFee: "Transferencia de Productos con Tasa Especial",
				floorComplement: "Complemento de mínimo garantizado",
				rechargeLeftovers: "Sobra de recarga",
			},
		},
		totalizers: {
			totalSold: "Facturación total de los vendors",
			totalReceipt: "Ingreso total con vendors",
			highestVendor: "Mayor vendor",
		},
		emptyState: {
			title: "Ninguna información encontrada",
			description: "No pudimos encontrar ningún dato en el período seleccionado.",
			subDescription: "Verifique si el período es válido o intente nuevas fechas.",
		},
	},
};
